import Basic from "./Basic";
import Default from "./Hero";
import ServiceLanding from "./ServiceLanding";
/**
 * @typedef {import("@prismicio/client").Content.HeroSlice} HeroSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<HeroSlice>} HeroProps
 * @param { HeroProps }
 */

const Hero = ({ slice: { primary, variation } }) => {
	switch (variation) {
		case "default":
			return <Default primary={primary} />;
		case "basic":
			return <Basic primary={primary} />;
		case "serviceLanding":
			return <ServiceLanding primary={primary} />;
		default:
			return null;
	}
};

export default Hero;
